import {NANO21_MODEL,NANO21_RATIOS} from './nanoBanana21';
export const SUNBURST_MODEL = 'gpt-image-2.5-sunburst' as const;
/** GPT Image edits/generations accept at most 32,000 prompt characters. */
export const GPT_IMAGE_PROMPT_MAX_CHARS = 32000;
export function assertGptImagePrompt(prompt:unknown):void {
 if(typeof prompt==='string'&&Array.from(prompt).length>GPT_IMAGE_PROMPT_MAX_CHARS)throw Object.assign(new Error('The complete image brief exceeds the selected GPT Image model’s 32,000-character limit. Shorten its visual brief; no image request was submitted.'),{code:'IMAGE_PROMPT_TOO_LONG'});
}
export const SUNBURST_QUALITIES = ['low','medium','high','xhigh','max'] as const;
export const SUNBURST_RESOLUTIONS = ['1k','2k','4k'] as const;
export const SUNBURST_RATIOS = ['1:1','3:2','2:3','3:4','4:3','4:5','5:4','9:16','16:9','21:9','2:1','1:2','3:1','1:3','9:21'] as const;
export type SunburstQuality = typeof SUNBURST_QUALITIES[number];
export type SunburstResolution = typeof SUNBURST_RESOLUTIONS[number];
export const SUNBURST_EXTRA_REFERENCE_KEY = `${SUNBURST_MODEL}/edit-extra-reference`;
export function sunburstPricingKey(operation:'edit'|'text-to-image',resolution:unknown,quality:unknown){
 if(!SUNBURST_RESOLUTIONS.includes(resolution as any)||!SUNBURST_QUALITIES.includes(quality as any))throw new Error('Invalid Sunburst pricing dimensions');
 return `${SUNBURST_MODEL}/${operation}-${resolution}-${quality}`;
}
export function sunburstRequest(body:{prompt?:string;images?:string[];aspect_ratio?:string;resolution?:string;quality?:string;[key:string]:unknown},operation:'edit'|'text-to-image'){
 const resolution=body.resolution??'1k';const quality=body.quality??'medium';
 sunburstPricingKey(operation,resolution,quality);
 if(body.aspect_ratio&&!SUNBURST_RATIOS.includes(body.aspect_ratio as any))throw new Error('Unsupported Sunburst aspect ratio');
 if(!body.prompt?.trim())throw new Error('Sunburst prompt is required');
 assertGptImagePrompt(body.prompt);
 if(operation==='edit'&&(!body.images?.length||body.images.length>16))throw new Error('Sunburst edit requires 1–16 reference images');
 return {...body,resolution,quality,output_format:'jpeg'};
}
/** Only composer selections migrate. Server defaults and historical receipts retain their model. */
export const NANO21_COMPOSER_DEFAULT_RESOLUTION = '4k' as const;
/** A fresh image Create-ad defaults to Nano; saved choices and existing Canvas keep their policy. */
export function newTaskImageModel<T extends string>(model:T,userSelected?:boolean,medium?:string):T|typeof NANO21_MODEL{
 return userSelected===false&&medium!=='video'?NANO21_MODEL:model;
}
const nanoResolution = (tier: string | null) => tier === '1k' || tier === '2k' || tier === '4k' ? tier : null;
/** Nano uses the tier dial, not GPT's independent resolution preference. */
export function canvasImageSelection(model:string,tier:string|null,resolution?:string|null){
 const selectedModel=model==='gpt-image-2'?SUNBURST_MODEL:model==='nano-banana-2'?NANO21_MODEL:model;
 if(selectedModel===NANO21_MODEL){
  const selectedResolution=nanoResolution(tier)??NANO21_COMPOSER_DEFAULT_RESOLUTION;
  return {model:selectedModel,tier:selectedResolution,resolution:selectedResolution};
 }
 return {model:selectedModel,tier,resolution:resolution??(model==='gpt-image-2'?'4k':'1k')};
}
/** A new family gets its default; reselecting Nano preserves its manual dial. */
export function canvasImageTierOnModelPick(previousModel:string,previousTier:string|null,model:string):string|null {
 if(model===NANO21_MODEL)return previousModel===NANO21_MODEL||previousModel==='nano-banana-2'
  ? nanoResolution(previousTier)??NANO21_COMPOSER_DEFAULT_RESOLUTION : NANO21_COMPOSER_DEFAULT_RESOLUTION;
 return model==='nano-banana-2'?null:'medium';
}

/** Legacy providers retain their original nine-ratio snapping boundary. */
export const LEGACY_IMAGE_ASPECT_RATIOS = ['1:1','9:16','16:9','4:5','5:4','3:4','4:3','2:3','3:2'] as const;
export function supportedImageRatios(model?:string):readonly string[] {
 return model===SUNBURST_MODEL ? SUNBURST_RATIOS : model===NANO21_MODEL ? NANO21_RATIOS : LEGACY_IMAGE_ASPECT_RATIOS;
}
